export function OarCaprera() {
  return (
    <svg
      width="312.72833"
      height="650"
      viewBox="0 0 82.742702 171.97917"
      version="1.1"
      id="caprera"
    >
      <defs id="defs1" />
      <g id="layer1">
        <rect
          fill="#52673d"
          id="rect1"
          width="82.742706"
          height="171.97917"
          x="-0.19270325"
          y="1.527482e-14"
        />
        <rect
          fill="#ffffff"
          id="rect2-8"
          width="20.160427"
          height="171.97917"
          x="25.703812"
          y="0"
        />
      </g>
    </svg>
  );
}
